export const AlertPlugin = {
    install(Vue, { store }) {
      if (!store) {
        throw new Error("A Vuex store needs to be provided");
      }
  
      store.registerModule("alerts", {
        state: {
          message: "",
          show: false,
          variant: "danger",
          timeout: null,
        },
        mutations: {
          SHOW_ALERT(state, { message, variant }) {
            state.message = message;
            state.variant = variant;
            state.show = true;
          },
          TIMEOUT_RESET(state, duration) {
            clearTimeout(state.timeout);
            state.timeout = setTimeout(() => {
              state.show = false;
              state.message = "";
              state.variant = "danger";
            }, duration);
          },
        },
        actions: {
          showAlert(
            { commit },
            { message = "", variant = "danger", duration = 5000 }
          ) {
            return new Promise((resolve) => {
              commit("SHOW_ALERT", { message, variant });
              commit("TIMEOUT_RESET", duration);
              resolve();
            });
          },
        },
      });
  
      Vue.prototype.$showAlert = function (message, variant, duration) {
        store.dispatch("showAlert", { message, variant, duration });
      };
    },
  };
  